module.exports = __webpack_public_path__ + "static/featured_story-b368f7f7c3511743840ec9f5449a93b7.webp";